import React, { useEffect, useRef, useState } from "react";
import Header from "../Header";
import Loader from "../Utils/Loader";
import {
  handleGetApiGF,
  isWebView,
  shareIphonePostMsg,
  Toast,
} from "../Utils/general-function";
import { Link } from "react-router-dom";
import callgreenimg from "../../src_img/callgreen.png";
const LeadTemporyListAlert = () => {
  const [loader, setLoader] = useState(true);
  const [data, setData] = useState([]);
  const isCalled = useRef(false);

  const fetchLeads = async () => {
    if (isCalled.current) return;
    isCalled.current = true;
    const res = await handleGetApiGF({
      url: "/api/LeadQRCode/GetUnreadLeadsList",
    });
    console.log("res not cou", res);

    if (!res?.succ) {
      Toast(false, "", res?.msg || "No new leads");
      setLoader(false);
      return;
    }

    setData(res?.data?.Data || []);
    setLoader(false);
  };
  useEffect(() => {
    fetchLeads();
  }, []);

  return (
    <div>
      <Header />
      {loader ? <Loader /> : null}

      <div className="page-space">
        <div className="d-flex align-items-center justify-content-between pb-3">
          <h2 className="page-title">New Leads</h2>
          <Link to="/Leaddata" className="submitbtn">
            All
          </Link>
        </div>
        <div className="">
          {data.length === 0 ? (
            <h3 className="text-center m-0 py-3" style={{ color: "#ff002a" }}>
              No Records Available
            </h3>
          ) : (
            <>
              {data.map((data, index) => (
                <div className="car-docsdiv" key={index}>
                  <div className="form-check-inline">
                    <label
                      className="form-check-label"
                      style={{ fontSize: "14px" }}
                    >
                      {data?.Modelyear && (
                        <h3>
                          {data?.Modelyear} {data?.companyname} {data?.carname}{" "}
                          {data?.variantname}
                        </h3>
                      )}
                    </label>
                  </div>
                  {/*------------------------------- Actual list---------------------- */}
                  <div className="list-grid">
                    <div className="list-details">
                      <div className="myflex">
                        <span>
                          <img src="assets/images/calender-svg.svg" alt="" />
                        </span>
                        <span className="title">{data.createdate}</span>
                      </div>
                    </div>
                    <div className="list-details">
                      <div className="myflex">
                        <span>
                          <img src="assets/images/profile-svg.svg" alt="" />
                        </span>
                        <span className="title">{data.Name}</span>
                      </div>
                    </div>
                    <div className="list-details">
                      <div className="myflex">
                        <span>
                          <img src="assets/images/car-num.svg" alt="" />
                        </span>
                        <span className="title">
                          {data.Carno && data.Carno !== "undefined"
                            ? data.Carno
                            : "-----"}
                        </span>
                      </div>
                    </div>
                    <div className="list-details">
                      <div className="myflex">
                        {isWebView() ? (
                          <span
                            style={{ color: "#ff002a" }}
                            onClick={() =>
                              shareIphonePostMsg({
                                action: "open_url_linking",
                                url: "tel:" + data.Contactno,
                              })
                            }
                          >
                            {/* <img src="assets/images/call-svg.svg" alt="" /> */}
                            <img src={callgreenimg} alt="" />
                          </span>
                        ) : (
                          <span>
                            <a
                              style={{ color: "#ff002a" }}
                              href={"tel:" + data.Contactno}
                            >
                              {/* <img src="assets/images/call-svg.svg" alt="" /> */}
                              <img src={callgreenimg} alt="" />
                            </a>
                          </span>
                        )}
                        <span className="title">
                          {isWebView() ? (
                            <span
                              onClick={() =>
                                shareIphonePostMsg({
                                  action: "open_url_linking",
                                  url: "tel:" + data.Contactno,
                                })
                              }
                              style={{ color: "#E62E2D" }}
                            >
                              {" "}
                              {data.Contactno}
                            </span>
                          ) : (
                            <a
                              style={{ color: "#ff002a" }}
                              href={"tel:" + data.Contactno}
                            >
                              {data.Contactno}
                            </a>
                          )}
                        </span>
                      </div>
                    </div>
                  </div>

                  {data.leadModelnamelist && (
                    <div className="list-details mt-2">
                      <div className="myflex align-items-start">
                        <span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            x="0"
                            y="0"
                            viewBox="0 0 512 512"
                          >
                            <g>
                              <path
                                d="M43.95 355.171h24.153c3.027 29.103 27.694 51.87 57.583 51.87 29.89 0 54.558-22.767 57.585-51.87h145.838c3.027 29.103 27.694 51.87 57.583 51.87 29.888 0 54.556-22.767 57.583-51.87h23.826c19.62 0 35.444-15.801 35.444-35.444 0-12.439-2.444-24.575-7.263-36.076a92.632 92.632 0 0 0-19.023-28.751c-30.448-31.497-54.735-18.262-73.834-48.594l-33.302-52.799c-19.176-30.401-52.082-48.547-88.026-48.547H196.38c-38.185 0-73.231 20.875-91.458 54.481l-23.39 43.108c-13.402 24.754-36.594 26.341-50.006 32.932-34.127 12.871-19.272 54.774-22.692 84.576 0 19.362 15.754 35.114 35.116 35.114zm81.737 39.804c-25.273 0-45.835-20.564-45.835-45.837s20.562-45.837 45.835-45.837c25.275 0 45.837 20.564 45.837 45.837s-20.562 45.837-45.837 45.837zm261.005 0c-25.273 0-45.835-20.564-45.835-45.837s20.562-45.837 45.835-45.837 45.835 20.564 45.835 45.837-20.562 45.837-45.835 45.837zm83.521-129.848a81.188 81.188 0 0 1 10.774 14.828h-36.603c-4.072 0-7.386-3.337-7.386-7.442a7.28 7.28 0 0 1 2.182-5.213 7.32 7.32 0 0 1 5.204-2.173zM35.782 246.774c12.111-6.089 40.311-8.814 56.357-38.48l23.388-43.103c16.117-29.708 47.098-48.166 80.853-48.166h85.717c31.775 0 60.868 16.044 77.822 42.92l33.3 52.794c19.173 30.458 38.855 23.44 63.259 40.323h-12.094c-5.185 0-10.065 2.031-13.69 5.661-3.662 3.582-5.762 8.607-5.762 13.791 0 10.756 8.727 19.508 19.452 19.508h42.114c3.242 8.908 4.982 18.195 4.982 27.705a23.313 23.313 0 0 1-23.378 23.378h-23.826c-3.027-29.103-27.694-51.87-57.583-51.87-29.888 0-54.556 22.767-57.583 51.87H183.272c-3.027-29.103-27.695-51.87-57.585-51.87-29.888 0-54.556 22.767-57.583 51.87H43.95c-12.71 0-23.051-10.341-23.051-23.048v-33.964h15.04a6.033 6.033 0 1 0 0-12.066H20.9v-5.675c0-9.55 5.981-18.222 14.882-21.578z"
                                fill="#000000"
                                opacity="1"
                                data-original="#000000"
                              ></path>
                              <path
                                d="M121.393 221.718H361.243a6.024 6.024 0 0 0 5.281-3.12 6.03 6.03 0 0 0-.177-6.132l-24.849-39.413c-14.991-23.788-40.73-37.989-68.848-37.989H206.8a81.304 81.304 0 0 0-71.553 42.613l-17.948 33.121c-.217.401-.46.787-.7 1.169l-.351.566a6.032 6.032 0 0 0 5.145 9.185zm209.896-42.232 19.018 30.165H250.093v-62.522h22.558c23.948 0 45.87 12.094 58.638 32.357zm-185.432 3.94a69.253 69.253 0 0 1 60.943-36.297h31.226v62.522H131.644zM289.169 238.832h-24.705a6.033 6.033 0 1 0 0 12.066h24.705a6.033 6.033 0 1 0 0-12.066zM162.495 238.832H137.79a6.033 6.033 0 1 0 0 12.066h24.705a6.033 6.033 0 1 0 0-12.066zM386.695 318.619c-16.829 0-30.519 13.692-30.519 30.519s13.69 30.514 30.519 30.514c16.827 0 30.514-13.688 30.514-30.514s-13.688-30.519-30.514-30.519zm0 48.967c-10.174 0-18.453-8.277-18.453-18.448 0-10.176 8.279-18.453 18.453-18.453 10.171 0 18.448 8.277 18.448 18.453 0 10.171-8.277 18.448-18.448 18.448zM125.689 318.619c-16.827 0-30.516 13.692-30.516 30.519s13.69 30.514 30.516 30.514 30.514-13.688 30.514-30.514-13.687-30.519-30.514-30.519zm0 48.967c-10.174 0-18.45-8.277-18.45-18.448 0-10.176 8.277-18.453 18.45-18.453 10.171 0 18.448 8.277 18.448 18.453 0 10.171-8.277 18.448-18.448 18.448z"
                                fill="#000000"
                                opacity="1"
                                data-original="#000000"
                              ></path>
                            </g>
                          </svg>
                        </span>
                        <span className="title" style={{ fontSize: "12px" }}>
                          {data.leadModelnamelist}
                        </span>
                      </div>
                    </div>
                  )}

                  {data.nRemarks && (
                    <div className="list-details mt-1">
                      <div className="myflex">
                        <span>
                          <img src="assets/images/info-svg.svg" alt="" />
                        </span>
                        <span className="title" style={{ fontWeight: "500" }}>
                          {data.nRemarks}
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default LeadTemporyListAlert;
